import React from 'react';

// Helpers
import valueValidator from '../../helpers/valueValidator';

// Styles
import {
	ContentWrapperStyled,
	HeaderWrapperStyled,
	InformationContainerStyled,
	InformationWrapperStyled,
	MetricWrapperStyled,
	LinkWrapperStyled,
} from './SidePanelEntry.styled';

import {
	TitleStyled,
	LabelStyled,
	ValueStyled,
} from '../../library/Text.styled';

import { LinkStyled } from '../../library/Links.styled';
import { RightLinkArrowIconStyled } from '../../library/Icons.styled';

const SidePanelEntry = (props) => {
	const { entry } = props;

	const hasGeographicLocation =
		entry.hasOwnProperty('lat') && entry.hasOwnProperty('long');

	// Some formatting
	const venue = hasGeographicLocation
		? `${entry.venue} ${entry.venue4} ${entry.postcode}`
		: 'Distance Learning';
	const date = `${entry.startdate} - ${entry.enddate}`;
	const time = `${entry.time} - ${entry.endtime}`;
	const price = entry.price === -1 ? 'Free' : '£' + entry.price;

	// Add some color classes to the entries
	const classes = 'color-white';

	return (
		<ContentWrapperStyled>
			<HeaderWrapperStyled>
				<TitleStyled className={'color-white large'}>
					{entry.classtitle}
				</TitleStyled>
			</HeaderWrapperStyled>
			<InformationContainerStyled>
				<InformationWrapperStyled>
					<MetricWrapperStyled>
						<LabelStyled className={classes}>Level:</LabelStyled>
						<ValueStyled className={classes}>
							{valueValidator(entry.level)}
						</ValueStyled>
					</MetricWrapperStyled>
					<MetricWrapperStyled>
						<LabelStyled className={classes}>Cost:</LabelStyled>
						<ValueStyled className={classes}>
							{valueValidator(price)}
						</ValueStyled>
					</MetricWrapperStyled>
					<MetricWrapperStyled>
						<LabelStyled className={classes}>Venue:</LabelStyled>
						<ValueStyled
							className={
								!hasGeographicLocation
									? 'distance-learning-course ' + classes
									: classes
							}
						>
							{valueValidator(venue)}
						</ValueStyled>
					</MetricWrapperStyled>
					<MetricWrapperStyled>
						<LabelStyled className={classes}>Date:</LabelStyled>
						<ValueStyled className={classes}>
							{valueValidator(date)}
						</ValueStyled>
					</MetricWrapperStyled>
					<MetricWrapperStyled>
						<LabelStyled className={classes}>Time:</LabelStyled>
						<ValueStyled className={classes}>
							{valueValidator(time)}
						</ValueStyled>
					</MetricWrapperStyled>
					<MetricWrapperStyled>
						<LabelStyled className={classes}>Contact:</LabelStyled>
						<ValueStyled className={classes}>
							{valueValidator(entry.courseprovider)}
						</ValueStyled>
					</MetricWrapperStyled>
					<MetricWrapperStyled>
						<LabelStyled className={classes}>Tel:</LabelStyled>
						<ValueStyled className={classes}>
							{valueValidator(entry.contacttelephone)}
						</ValueStyled>
					</MetricWrapperStyled>
					{entry.contactemail && (
						<MetricWrapperStyled>
							<LabelStyled className={classes}>Email:</LabelStyled>
							<ValueStyled className={classes + ' break-word'}>
								<a
									href={'mailto:' + entry.contactemail}
									target={'_blank'}
									rel={'noreferrer'}
								>
									{entry.contactemail}
								</a>
							</ValueStyled>
						</MetricWrapperStyled>
					)}
					<MetricWrapperStyled>
						<LabelStyled className={classes}>More Info:</LabelStyled>
						<ValueStyled className={classes + ' hyphens'}>
							{valueValidator(entry.otherinfo)}
						</ValueStyled>
					</MetricWrapperStyled>
					<LinkWrapperStyled>
						{entry.contactwebsite && (
							<LinkStyled
								href={entry.contactwebsite}
								target={'_blank'}
								rel={'noreferrer'}
							>
								Go to website
								<RightLinkArrowIconStyled />
							</LinkStyled>
						)}
					</LinkWrapperStyled>
				</InformationWrapperStyled>
			</InformationContainerStyled>
		</ContentWrapperStyled>
	);
};

export default SidePanelEntry;
